/* eslint-disable react/function-component-definition */
import * as React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import { mobileSize } from '../../util/variables';

export interface ModalProps {
  showModal: boolean;
  label: string;
  toggleModal: () => void;
  children: React.ReactNode;
  height?: string;
  width?: string;
  maxHeight?: string;
  zIndex?: string;
  background?: string;
  backgroundColor?: string;
  scrollContentOnly?: boolean;
}

export interface ModalState {}

class Modal extends React.Component<ModalProps, ModalState> {
  public render(): JSX.Element {
    const {
      showModal,
      label,
      toggleModal,
      children,
      height,
      width,
      maxHeight,
      zIndex = '1200',
      background = '#fff',
      backgroundColor = '#1a1a1a',
      scrollContentOnly = false,
      ...props
    } = this.props;

    return (
      <StyledModal
        shouldCloseOnOverlayClick={false}
        isOpen={showModal}
        contentLabel={label}
        ariaHideApp={false}
        height={height}
        width={width}
        maxHeight={maxHeight}
        zIndex={zIndex}
        background={background}
        backgroundColor={backgroundColor}
        scrollContentOnly={scrollContentOnly}
        {...props}
        onRequestClose={toggleModal}
      >
        {children}
      </StyledModal>
    );
  }
}

function ReactModalAdapter({
  className,
  children,
  maxHeight,
  scrollContentOnly,
  ...props
}: any) {
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return (
    <ReactModal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
      children={children}
    />
  );
}

interface AdditionalModalProps {
  width?: '903px';
  height?: '475px';
  maxHeight?: string;
  zIndex?: '10';
  scrollContentOnly?: boolean;
}

const StyledModal = styled(ReactModalAdapter)<AdditionalModalProps>`
  &__overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: ${props => props.backgroundColor};
    z-index: ${props => props.zIndex};
    overflow-y: auto;
    ${props =>
      props.scrollContentOnly &&
      `
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      @media ${mobileSize} {
        overflow: auto;
        display: block;
        padding: 0;
        align-items: initial;
        justify-content: initial;
      }
    `}
  }
  &__content {
    width: ${props => props.width};
    height: ${props => props.height};
    max-height: ${props => (props.scrollContentOnly ? props.maxHeight || 'none' : 'none')};
    max-width: ${props => (props.scrollContentOnly ? '100%' : 'none')};
    min-width: ${props => (props.scrollContentOnly ? '0' : 'auto')};
    margin: ${props => (props.scrollContentOnly ? '0' : 'auto')};
    background: ${props => props.background};
    overflow-x: ${props => (props.scrollContentOnly ? 'hidden' : 'visible')};
    overflow-y: ${props => (props.scrollContentOnly ? 'hidden' : 'auto')};
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    @media ${mobileSize} {
      max-height: none;
      max-width: none;
      min-width: auto;
      margin: auto;
      overflow-x: visible;
      overflow-y: auto;
    }
  }
`;

StyledModal.defaultProps = {
  width: 'fit-content',
  height: 'fit-content',
};

export { Modal };
